import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navigation from './Components/Navigation';
// import Chat from './Components/Chat'

function App() {
    return (
      <div>
        <Navigation/>
        {/* <Chat/> */}
      </div>
    );
}

export default App;
